// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".styles-cls1___7697c25aaad302bfb59{/*!*/}.styles-cls2___16b249ad2c7ab28e90b{position:relative;display:flex;align-items:flex-start;align-self:stretch;white-space:nowrap}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "styles-cls1___7697c25aaad302bfb59",
	"cls2": "styles-cls2___16b249ad2c7ab28e90b styles-cls1___7697c25aaad302bfb59"
};
export default ___CSS_LOADER_EXPORT___;
